import { Circle, Fill, RegularShape, Stroke, Style, Text, Icon } from "ol/style";
import CircleStyle from "ol/style/Circle";
import { formatArea, formatLength } from "../mapFunctions/measureFunctions/mapMathFormatters";
import { LineString, Point } from "ol/geom";

const fastTransportIconSrc = require('../../../../assets/images/mapIcons/arrow-green.png')
const slowTransportIconSrc = require('../../../../assets/images/mapIcons/arrow-orange.png')
const stayTransportIconSrc = require('../../../../assets/images/mapIcons/arrow-gray.png')

export const mapStylesColors = {
    mustard: "#EAAA00"
}

export function getStyleForBasicFeature(feature: any) {
    return basicStyles[feature.getGeometry().getType()];
}

export function getStyleForRosreestrFeature(feature: any) {
    return rosreestrStyles[feature.getGeometry().getType()];
}

export function getColorBackgroundStyle(color: any, width: any) {
    return new Style({
        stroke: new Stroke({ color, width })
    })
}

export function getCameraMarkerStyle(angle: any) {
    return new Style({
        image: new Icon({
            anchor: [0.5, 45],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            rotation: (parseFloat(angle)) / 180 * Math.PI,
            src: `${process.env.PUBLIC_URL}/assets/images/pano/radar.png`,
            scale: 1
        }),
    })
}

export function getLineStyle(color: any, width: any, lineDash?: any) {
    return new Style({
        stroke: new Stroke({ color, width, lineDash })
    })
}

export const rosreestrStyles: any = {
    'MultiPolygon': new Style({
        stroke: new Stroke({
            color: 'blue',
            width: 2,
        })
    }),
    'Polygon': new Style({
        stroke: new Stroke({
            color: 'blue',
            width: 2
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
        })
    })
};

export const basicStyles: any = {
    'LineString': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 3,
        }),
    }),
    'MultiLineString': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 4,
        }),
    }),
    'MultiPolygon': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 1,
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 0, 0.4)',
        }),
    }),
    'Polygon': new Style({
        stroke: new Stroke({
            color: 'red',
            lineDash: [4],
            width: 3,
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
        }),
    }),
    'GeometryCollection': new Style({
        stroke: new Stroke({
            color: 'red',
            lineDash: [4],
            width: 2,
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 0, 0.4)',
        }),
        image: new CircleStyle({
            radius: 10,
            fill: undefined,
            stroke: new Stroke({
                color: 'red',
                width: 2,
            }),
        }),
    }),
    'Circle': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 2,
        }),
        fill: new Fill({
            color: 'rgba(255,0,0,0.2)',
        }),
    }),
    'Point': new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.6)',
        }),
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 2,
        }),
        image: new CircleStyle({
            radius: 15,
            stroke: new Stroke({
                color: 'red',
            }),
            fill: new Fill({
                color: 'rgba(255,0,0,0.2)',
            }),
        }),
    }),
};

// Стиль для маркера перед началом измерений
export const modifyStyle: any = new Style({
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 0, 0.4)',
        }),
    }),
    text: new Text({
        text: 'Переместите для редактирования',
        font: '12px Arial,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgb(52,152,219,0.8)',
        }),
        padding: [2, 2, 2, 2],
        textAlign: 'left',
        offsetX: 15,
    }),
});
export const measuringStyle = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 0.6)',
    }),
    stroke: new Stroke({
        color: 'red',
        lineDash: [10, 10],
        width: 2,
    }),
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.6)',
        }),
    }),
})
// Стиль маркеров с вычислениями
export const labelStyle = new Style({
    text: new Text({
        font: '14px Arial,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgb(52,152,219,0.8)',
        }),
        padding: [3, 3, 3, 3],
        textBaseline: 'bottom',
        offsetY: -15,
    }),
    image: new RegularShape({
        radius: 8,
        points: 3,
        angle: Math.PI,
        displacement: [0, 10],
        fill: new Fill({
            color: 'rgb(52,152,219,0.8)',
        }),
    }),
});
// Стиль внутренней площади
export const tipStyle = new Style({
    text: new Text({
        font: '12px Arial,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgba(0, 0, 0, 0.45)',
        }),
        backgroundStroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.45)',
            width: 2,
            // radius: 6, // Задайте значение радиуса для закругления краев
        }),
        padding: [2, 2, 2, 2],
        textAlign: 'left',
        offsetX: 25,
        offsetY: -15,
    }),
});

// Стиль маркера для измерений
export const segmentStyle = new Style({
    text: new Text({
        font: '12px Arial,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgb(52,152,219,0.8)',
        }),
        padding: [2, 2, 2, 2],
        textBaseline: 'bottom',
        offsetY: -12,
    }),
    image: new RegularShape({
        radius: 6,
        points: 3,
        angle: Math.PI,
        displacement: [0, 8],
        fill: new Fill({
            color: 'rgb(52,152,219,0.8)',
        }),
    }),
});

// Стили для сегментов при измерении
export const segmentStyles = [segmentStyle];

//Стиль для подписей кадастровых округов
export let styleLabelPKK8 = new Style({
    text: new Text({
        font: '16px Arial,sans-serif',// Размер и шрифт
        fill: new Fill({		// Цвет текста
            color: '#AA0000'
        }),
        stroke: new Stroke({	// Белая обводка вокруг текста
            color: '#FFFFFF',
            width: 4
        })
    })
});
// Стиль для подписей кадастровых кварталов
export let styleLabelPKK11 = new Style({
    text: new Text({
        font: '11px Arial,sans-serif',
        fill: new Fill({
            color: '#FF0000'
        }),
        stroke: new Stroke({
            color: '#FFFFFF',
            width: 1
        })
    })
});
// Стиль кадастровых округов
export let okrugStyle = new Style({
    // fill: new ol.style.Fill({
    // 	color: 'rgba(255, 255, 255, 0)'
    // }),
    stroke: new Stroke({
        color: '#AA0000',
        width: 2
    })
});
// Стиль для кадастровых кварталов
export let kvartalStyle = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 0)'
    }),
    stroke: new Stroke({
        color: '#FF0000',
        width: 1
    })
});
// Стиль для кадастровых районов
export let rayonStyle = new Style({
    // fill: new ol.style.Fill({
    // 	color: 'rgba(255, 255, 255, 0)'
    // }),
    stroke: new Stroke({
        color: '#FF0000',
        width: 1
    })
});

export let highlightedHighwayNetworkSegment = new Style({
    stroke: new Stroke({
        color: '#8b00ff',
        width: 3
    })
})

//Функция для кнопки копирования координат
export const copyMarkerStyle = new Style({
    image: new Circle({
        radius: 6,
        fill: new Fill({ color: 'rgb(52,152,219,0.7)' }),
        stroke: new Stroke({ color: 'rgba(255, 255, 255, 0.7)', width: 2 }),
    }),
    text: new Text({
        text: 'Скопировать в буфер обмена',
        font: '12px Arial,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgb(52,152,219,0.7)',
        }),
        backgroundStroke: new Stroke({
            color: 'rgba(255, 255, 255, 1)',
            width: 1,
        }),
        padding: [2, 2, 2, 2],
        textAlign: 'left',
        offsetX: 25,
        offsetY: -15,
    })
});

//Функция для кнопки копирования координат
export const goToYandexMirrorsMarkerStyle = new Style({
    image: new Circle({
        radius: 6,
        fill: new Fill({ color: 'rgb(52,152,219,0.7)' }),
        stroke: new Stroke({ color: 'rgba(255, 255, 255, 0.7)', width: 2 }),
    }),
    text: new Text({
        text: 'Открыть позицию в Яндекс Зеркала',
        font: '12px Arial,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgb(52,152,219,0.7)',
        }),
        backgroundStroke: new Stroke({
            color: 'rgba(255, 255, 255, 1)',
            width: 1,
        }),
        padding: [2, 2, 2, 2],
        textAlign: 'left',
        offsetX: 25,
        offsetY: -15,
    })
});

export const transportMonitoringBadgeStyle = new Text({
    text: "",
    font: "10px 'PT Sans', Tahoma",
    offsetX: 0,
    offsetY: 20,
    fill: new Fill({ color: "#666" }),
    stroke: new Stroke({ width: 3, color: "#fff" })
});

export const transportMonitoringArrowStyle = (feature: any, showNumbers: any) => {
    let props = feature.getProperties();
    let textStyle = transportMonitoringBadgeStyle;
    textStyle.setText(props.hasOwnProperty("stateNumber") && props.stateNumber !== undefined && showNumbers ? props.stateNumber : "");

    return new Style({
        image: new Icon({
            anchor: [0.5, 0.5],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: props.speed > 30 ? fastTransportIconSrc : // fast
                props.speed > 1 ? slowTransportIconSrc : // slow
                    stayTransportIconSrc, // stay
            rotation: props.azimuth * Math.PI / 180
        }),
        text: textStyle
    });
}

// Функция стилей для измерителей карты
export function measureSegmentsStyle(modify: any, feature: any, segments: any, drawType?: any, tip?: any) {
    const styles = [];
    const geometry = feature.getGeometry();
    const type = geometry.getType();
    let point, label, line;
    if (!drawType || drawType === type || type === 'Point') {
        styles.push(measuringStyle);
        if (type === 'Polygon') {
            point = geometry.getInteriorPoint();
            label = formatArea(geometry);
            line = new LineString(geometry.getCoordinates()[0]);
        } else if (type === 'LineString') {
            point = new Point(geometry.getLastCoordinate());
            label = formatLength(geometry);
            line = geometry;
        }
    }
    if (segments && line) {
        let count = 0;
        line.forEachSegment(function (a: any, b: any) {
            const segment = new LineString([a, b]);
            const label = formatLength(segment);
            if (segmentStyles.length - 1 < count) {
                segmentStyles.push(segmentStyle.clone());
            }
            const segmentPoint = new Point(segment.getCoordinateAt(0.5));
            segmentStyles[count].setGeometry(segmentPoint);
            segmentStyles[count].getText().setText(label);
            styles.push(segmentStyles[count]);
            count++;
        });
    }
    if (label) {
        labelStyle.setGeometry(point);
        labelStyle.getText().setText(label);
        styles.push(labelStyle);
    }
    if (tip && type === 'Point' && !modify.getOverlay().getSource().getFeatures().length) {
        tipStyle.getText().setText(tip);
        styles.push(tipStyle);
    }
    return styles;
}

// Запросы в векторный pbf, применяем стили для слоев крупных масштабов 
export const styleFuncForCadastreVector = (feature: any, resolution: any) => {
    checkResolution(resolution);
    // Возьмём тип кадастрового слоя, к которому принадлежит фигура
    let featureLayer = feature.get('layer');
    // В зависимости от типа фигуры назначим стиль полигона
    if (featureLayer === 'Кадастровые округа:1' || featureLayer === 'Кадастровые округа:2') {
        return [okrugStyle];
    }
    if (featureLayer === 'Кадастровые районы:1' || featureLayer === 'Кадастровые районы:2') {
        return [rayonStyle];
    }
    if (featureLayer === 'Кадастровые кварталы') {
        return [kvartalStyle];
    }
    // Стили для подписей регионов и районов
    // для масштабных рядов выше 6 (zoomLevel<6)
    if (featureLayer === 'Кадастровые округа:1/label' || featureLayer === 'Кадастровые округа:2/label') {
        // Назначение текста для отображения
        return [LabelPKK8(feature)];
    }
    if (featureLayer === 'Кадастровые районы:2/label') {
        if (resolution > 1000) {
            // Назначение текста для отображения
            return [LabelPKK11(feature)];
        } else {
            // Получить label_class
            let labelClass = feature.get('_label_class');
            if (labelClass === 1)
                return [LabelPKK11(feature)];
        }
        return []
    }
    if (featureLayer === 'Кадастровые районы:1/label') {
        // Назначение текста для отображения
        return [LabelPKK11(feature)];
    }
    // Во всех остальных непонятных случаях:
    checkFeatureLayer(featureLayer);
    // Назначение текста для отображения
    // return [LabelPKK11(feature)];
}

// Получаем значение подписи из поля, применяем для подписей в крупных масштабах
export const LabelPKK8 = (feature: any) => {
    // Установим текст для отображения из свойств конкретной фигуры
    styleLabelPKK8.getText().setText(feature.get('_name'));
    // Вернём новообразованный стиль для работы
    return styleLabelPKK8;
}
export const LabelPKK11 = (feature: any) => {
    // Установим текст для отображения из свойств конкретной фигуры
    styleLabelPKK11.getText().setText(feature.get('_name'));
    // Вернём новообразованный стиль для работы
    return styleLabelPKK11;
}
let arAllCadastreLayersTypes: any[] = [];
export const checkFeatureLayer = (featureLayer: any) => {
    if (arAllCadastreLayersTypes.indexOf(featureLayer) < 0) {
        // Ранее не встречали => запомним, выведем на консоль
        arAllCadastreLayersTypes.push(featureLayer);
    }
}
let prevResolution = 0;
export const checkResolution = (resolution: any) => {
    let intResolution = Math.floor(resolution);
    if (prevResolution !== intResolution) {
        prevResolution = intResolution;
    }
}